export interface NutritionInfo {
  calories: number;
  proteins: number;
  carbs: number;
  fats: number;
  sodium: number;
  fiber: number;
  unit: string;
}

export interface NutritionRow {
  nutrient: string;
  per100g: string;
  per40g: string;
  vd: string;
}

export interface DetailedNutrition {
  allergens: string;
  conservation: string;
  shelfLife: string;
  rows: NutritionRow[];
}

export interface Product {
  id: string;
  name: string;
  shortDescription: string;
  fullDescription: string;
  ingredients: string[];
  weight: string;
  price: number;
  image: string;
  gallery: string[];
  category: string;
  badge: string | null;
  nutrition: NutritionInfo;
  detailedNutrition?: DetailedNutrition;
  conservation: string;
  shelfLife: string;
  storageTemp: string;
  tags: string[];
}

export const sandwiches: Product[] = [
  {
    id: "peito-de-peru",
    name: "Peito de Peru",
    shortDescription: "Classico e leve, perfeito para quem busca sabor sem exageros.",
    fullDescription: "Nosso sanduiche de Peito de Peru é preparado com pão de forma fresco, peito de peru defumado de alta qualidade e queijo mussarela derretido. Uma opção leve e equilibrada, ideal para lanches da tarde, cafés da manha ou como acompanhamento em eventos corporativos. A combinacao simples de ingredientes frescos resulta em um sabor delicado que agrada todos os paladares.",
    ingredients: ["Pão de forma", "Molho branco", "Peito de peru", "Queijo mussarela", "Cenoura ralada"],
    weight: "130g",
    price: 6.80,
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/cd2effe6-b912-4d1a-bc46-8d73ae018295_compressed_PEITO-DE-PERU.webp",
    gallery: [
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/cd2effe6-b912-4d1a-bc46-8d73ae018295_compressed_PEITO-DE-PERU.webp",
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/dc3213e2-dacf-4322-b387-e6b59204122c_compressed_sanduche_em_embalagem_colorida_ao_sol.webp",
    ],
    category: "sanduiches-naturais",
    badge: "Mais Vendido",
    nutrition: { calories: 245, proteins: 14.2, carbs: 28.5, fats: 8.3, sodium: 520, fiber: 1.8, unit: "por 100g" },
    detailedNutrition: {
      allergens: "Contém derivados de soja, trigo e leite. Pode conter ovo. Contém lactose. Contém glúten.",
      conservation: "Manter refrigerado entre 0°C e 5°C. Nao expor à luz solar direta.",
      shelfLife: "10 dias",
      rows: [
        { nutrient: "Valor energético (kcal)", per100g: "237", per40g: "92", vd: "5%" },
        { nutrient: "Carboidratos", per100g: "29 g", per40g: "11 g", vd: "4%" },
        { nutrient: "Açúcares totais", per100g: "4,6 g", per40g: "1,8 g", vd: "-" },
        { nutrient: "Açúcares adicionados", per100g: "2,8 g", per40g: "1,1 g", vd: "2%" },
        { nutrient: "Proteínas", per100g: "13 g", per40g: "5,1 g", vd: "10%" },
        { nutrient: "Gorduras totais", per100g: "7,7 g", per40g: "3,1 g", vd: "5%" },
        { nutrient: "Gorduras saturadas", per100g: "2,8 g", per40g: "1,1 g", vd: "6%" },
        { nutrient: "Gorduras trans", per100g: "0", per40g: "0", vd: "0%" },
        { nutrient: "Fibras alimentares", per100g: "2,8 g", per40g: "1,1 g", vd: "4%" },
        { nutrient: "Sódio", per100g: "377 mg", per40g: "151 mg", vd: "8%" },
      ],
    },
    conservation: "Manter refrigerado entre 0°C e 5°C. Nao expor à luz solar direta.",
    shelfLife: "10 dias",
    storageTemp: "0°C a 5°C",
    tags: ["Leve", "Classico", "Sem conservantes"],
  },
  {
    id: "peito-de-peru-mussarela",
    name: "Peito de Peru com Mussarela",
    shortDescription: "Defumado e cremoso, uma combinação que conquista a cada mordida.",
    fullDescription: "O sanduiche de Peito de Peru com Mussarela eleva o classico a outro nivel. O peito de peru defumado traz um sabor marcante, enquanto a mussarela cremosa adiciona uma textura irresistivel. Complementado por tomate fresco, cebolinha e um toque de curry, este sanduiche é uma explosao de sabores que transforma qualquer refeicao em um momento especial.",
    ingredients: ["Pão de forma", "Maionese caseira", "Peito de peru defumado", "Queijo mussarela", "Tomate", "Cebolinha", "Pepino", "Pasta de alho", "Curry"],
    weight: "130g",
    price: 6.80,
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/1c095fef-4661-4670-ac0c-ffe5fba0e6e1_compressed_PEITO-DE-PERU-E-MUSSARELA.webp",
    gallery: [
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/1c095fef-4661-4670-ac0c-ffe5fba0e6e1_compressed_PEITO-DE-PERU-E-MUSSARELA.webp",
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/dc3213e2-dacf-4322-b387-e6b59204122c_compressed_sanduche_em_embalagem_colorida_ao_sol.webp",
    ],
    category: "sanduiches-naturais",
    badge: null,
    nutrition: { calories: 268, proteins: 15.8, carbs: 26.2, fats: 11.5, sodium: 610, fiber: 2.1, unit: "por 100g" },
    detailedNutrition: {
      allergens: "Contém derivados de soja, trigo, ovo e leite. Contém lactose. Contém glúten.",
      conservation: "Manter refrigerado entre 0°C e 5°C. Consumir após descongelamento.",
      shelfLife: "10 dias",
      rows: [
        { nutrient: "Valor energético (kcal)", per100g: "209", per40g: "85", vd: "4%" },
        { nutrient: "Carboidratos", per100g: "29 g", per40g: "12 g", vd: "4%" },
        { nutrient: "Açúcares totais", per100g: "3 g", per40g: "1,2 g", vd: "-" },
        { nutrient: "Açúcares adicionados", per100g: "2,9 g", per40g: "1,2 g", vd: "2%" },
        { nutrient: "Proteínas", per100g: "8,6 g", per40g: "3,4 g", vd: "7%" },
        { nutrient: "Gorduras totais", per100g: "6,5 g", per40g: "2,6 g", vd: "4%" },
        { nutrient: "Gorduras saturadas", per100g: "2 g", per40g: "0,8 g", vd: "4%" },
        { nutrient: "Gorduras trans", per100g: "0", per40g: "0", vd: "0%" },
        { nutrient: "Fibras alimentares", per100g: "1,9 g", per40g: "0,8 g", vd: "3%" },
        { nutrient: "Sódio", per100g: "493 mg", per40g: "197 mg", vd: "10%" },
      ],
    },
    conservation: "Manter refrigerado entre 0°C e 5°C. Consumir após descongelamento.",
    shelfLife: "10 dias",
    storageTemp: "0°C a 5°C",
    tags: ["Cremoso", "Defumado", "Especial"],
  },
  {
    id: "peito-de-peru-minas",
    name: "Peito de Peru com Queijo Minas",
    shortDescription: "O toque mineiro que torna cada sanduiche inesquecivel.",
    fullDescription: "Inspirado nas tradicoes de Minas Gerais, este sanduiche combina o sabor suave do peito de peru com a riqueza do queijo minas frescal. O resultado é um lanche autentico e reconfortante, perfeito para quem aprecia sabores brasileiros com um toque artesanal. O molho branco caseiro harmoniza todos os ingredientes em uma experiencia gastronomica unica.",
    ingredients: ["Pão de forma", "Molho branco caseiro", "Peito de peru", "Queijo minas frescal"],
    weight: "130g",
    price: 6.80,
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/c360b390-358f-43c7-862a-cedc75369245_compressed_PEITO-DE-PERU-COM-QUEIJO-MINAS.webp",
    gallery: [
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/c360b390-358f-43c7-862a-cedc75369245_compressed_PEITO-DE-PERU-COM-QUEIJO-MINAS.webp",
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/dc3213e2-dacf-4322-b387-e6b59204122c_compressed_sanduche_em_embalagem_colorida_ao_sol.webp",
    ],
    category: "sanduiches-naturais",
    badge: null,
    nutrition: { calories: 272, proteins: 16.5, carbs: 25.8, fats: 12.1, sodium: 580, fiber: 1.5, unit: "por 100g" },
    detailedNutrition: {
      allergens: "Contém derivados de soja, trigo e leite. Pode conter ovo. Contém lactose. Contém glúten.",
      conservation: "Manter refrigerado entre 0°C e 5°C. Nao congelar após descongelamento.",
      shelfLife: "10 dias",
      rows: [
        { nutrient: "Valor energético (kcal)", per100g: "246", per40g: "98", vd: "5%" },
        { nutrient: "Carboidratos", per100g: "30 g", per40g: "12 g", vd: "4%" },
        { nutrient: "Açúcares totais", per100g: "4,9 g", per40g: "2 g", vd: "-" },
        { nutrient: "Açúcares adicionados", per100g: "3 g", per40g: "1,2 g", vd: "2%" },
        { nutrient: "Proteínas", per100g: "13 g", per40g: "5 g", vd: "10%" },
        { nutrient: "Gorduras totais", per100g: "8,2 g", per40g: "3,3 g", vd: "5%" },
        { nutrient: "Gorduras saturadas", per100g: "2 g", per40g: "0,8 g", vd: "4%" },
        { nutrient: "Gorduras trans", per100g: "0", per40g: "0", vd: "0%" },
        { nutrient: "Fibras alimentares", per100g: "2,8 g", per40g: "1,1 g", vd: "4%" },
        { nutrient: "Sódio", per100g: "362 mg", per40g: "145 mg", vd: "7%" },
      ],
    },
    conservation: "Manter refrigerado entre 0°C e 5°C. Nao congelar após descongelamento.",
    shelfLife: "10 dias",
    storageTemp: "0°C a 5°C",
    tags: ["Tradicional", "Queijo Minas", "Artesanal"],
  },
  {
    id: "atum",
    name: "Atum",
    shortDescription: "Sabor do mar em uma receita equilibrada e irresistivel.",
    fullDescription: "Nosso sanduiche de Atum traz o frescor do oceano para sua mesa. Preparado com patê de atum selecionado e uma maionese leve e cremosa, este sanduiche é uma opcao nutritiva e cheia de omega-3. A simplicidade da receita valoriza a qualidade dos ingredientes, resultando em um lanche saboroso e saudavel para qualquer momento do dia.",
    ingredients: ["Pão de forma", "Patê de atum premium", "Maionese caseira"],
    weight: "130g",
    price: 6.80,
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/f0b925df-e26f-4da5-96e0-10a0e72c4be7_compressed_ATUM.webp",
    gallery: [
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/f0b925df-e26f-4da5-96e0-10a0e72c4be7_compressed_ATUM.webp",
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/dc3213e2-dacf-4322-b387-e6b59204122c_compressed_sanduche_em_embalagem_colorida_ao_sol.webp",
    ],
    category: "sanduiches-naturais",
    badge: null,
    nutrition: { calories: 235, proteins: 13.8, carbs: 27.2, fats: 8.1, sodium: 495, fiber: 1.2, unit: "por 100g" },
    detailedNutrition: {
      allergens: "Contém derivados de soja, trigo e ovo. Pode conter leite. Contém glúten.",
      conservation: "Manter refrigerado entre 0°C e 10°C. Após aberto consumir imediatamente.",
      shelfLife: "10 dias",
      rows: [
        { nutrient: "Valor energético (kcal)", per100g: "206 kcal", per40g: "83 kcal", vd: "4%" },
        { nutrient: "Carboidratos", per100g: "32 g", per40g: "13 g", vd: "4%" },
        { nutrient: "Açúcares totais", per100g: "4,7 g", per40g: "1,9 g", vd: "-" },
        { nutrient: "Açúcares adicionados", per100g: "3 g", per40g: "1,2 g", vd: "2%" },
        { nutrient: "Proteínas", per100g: "5,2 g", per40g: "2,1 g", vd: "4%" },
        { nutrient: "Gorduras totais", per100g: "6,3 g", per40g: "2,5 g", vd: "4%" },
        { nutrient: "Gorduras saturadas", per100g: "1,1 g", per40g: "0,5 g", vd: "2%" },
        { nutrient: "Gorduras trans", per100g: "0 g", per40g: "0 g", vd: "0%" },
        { nutrient: "Fibras alimentares", per100g: "2,1 g", per40g: "0,9 g", vd: "2%" },
        { nutrient: "Sódio", per100g: "585 mg", per40g: "237 mg", vd: "4%" },
      ],
    },
    conservation: "Manter refrigerado entre 0°C e 5°C. Produto perecivel.",
    shelfLife: "10 dias",
    storageTemp: "0°C a 5°C",
    tags: ["Omega-3", "Marinho", "Saudavel"],
  },
  {
    id: "salpicao",
    name: "Salpicao",
    shortDescription: "Tradicional brasileiro com o crocante especial da batata palha.",
    fullDescription: "Uma homenagem à culinaria brasileira, nosso sanduiche de Salpicão é preparado com frango desfiado temperado, maionese caseira e vegetais frescos picados em cubinhos. A cobertura de batata palha crocante adiciona uma textura surpreendente que contrasta com a cremosidade do recheio. Um classico que nunca sai de moda e conquista todas as geracoes.",
    ingredients: ["Pão de forma", "Patê de salpicão", "Batata palha crocante"],
    weight: "130g",
    price: 6.80,
    image: "https://storage.helloreaddy.io/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/d61155e5-a1e7-436f-aa37-07b859367868_compressed_Captura-de-tela-2026-09-25-091409.webp",
    gallery: [
      "https://storage.helloreaddy.io/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/d61155e5-a1e7-436f-aa37-07b859367868_compressed_Captura-de-tela-2026-09-25-091409.webp",
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/dc3213e2-dacf-4322-b387-e6b59204122c_compressed_sanduche_em_embalagem_colorida_ao_sol.webp",
    ],
    category: "sanduiches-naturais",
    badge: null,
    nutrition: { calories: 285, proteins: 12.5, carbs: 30.1, fats: 13.2, sodium: 650, fiber: 1.9, unit: "por 100g" },
    detailedNutrition: {
      allergens: "Contém derivados de soja, trigo e ovo. Pode conter leite. Contém glúten.",
      conservation: "Manter refrigerado entre 0°C e 5°C. Batata palha separada em embalagem individual.",
      shelfLife: "10 dias",
      rows: [
        { nutrient: "Valor energético (kcal)", per100g: "196", per40g: "78", vd: "4%" },
        { nutrient: "Carboidratos", per100g: "30 g", per40g: "12 g", vd: "4%" },
        { nutrient: "Açúcares totais", per100g: "4 g", per40g: "1,6 g", vd: "-" },
        { nutrient: "Açúcares adicionados", per100g: "3 g", per40g: "1,2 g", vd: "2%" },
        { nutrient: "Proteínas", per100g: "8,6 g", per40g: "3,5 g", vd: "7%" },
        { nutrient: "Gorduras totais", per100g: "4,5 g", per40g: "1,8 g", vd: "3%" },
        { nutrient: "Gorduras saturadas", per100g: "0,9 g", per40g: "0,4 g", vd: "2%" },
        { nutrient: "Gorduras trans", per100g: "0", per40g: "0", vd: "0%" },
        { nutrient: "Fibras alimentares", per100g: "2,1 g", per40g: "0,9 g", vd: "4%" },
        { nutrient: "Sódio", per100g: "445 mg", per40g: "178 mg", vd: "9%" },
      ],
    },
    conservation: "Manter refrigerado entre 0°C e 5°C. Batata palha separada em embalagem individual.",
    shelfLife: "10 dias",
    storageTemp: "0°C a 5°C",
    tags: ["Tradicional", "Brasileiro", "Crocante"],
  },
  {
    id: "file-de-frango",
    name: "Filé de Frango",
    shortDescription: "O preferido dos amantes de frango, com um mix de sabores surpreendente.",
    fullDescription: "O sanduiche de Filé de Frango é um dos mais pedidos da Big Mania, e nao é por acaso. Preparado com peito de frango grelhado e desfiado, combinado com cenoura ralada, uva-passa e milho verde, este sanduiche oferece uma explosao de sabores e texturas em cada mordida. A maionese caseira temperada une todos os ingredientes em uma combinacao perfeita que agrada adultos e criancas.",
    ingredients: ["Pão de forma", "Patê de filé de frango grelhado", "Maionese caseira", "Cenoura ralada", "Uva-passa", "Milho verde"],
    weight: "130g",
    price: 6.80,
    image: "https://storage.helloreaddy.io/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/98f4cf33-f0eb-4056-a538-4754e54d35ca_compressed_Captura-de-tela-2026-09-30-071759.webp",
    gallery: [
      "https://storage.helloreaddy.io/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/98f4cf33-f0eb-4056-a538-4754e54d35ca_compressed_Captura-de-tela-2026-09-30-071759.webp",
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/dc3213e2-dacf-4322-b387-e6b59204122c_compressed_sanduche_em_embalagem_colorida_ao_sol.webp",
    ],
    category: "sanduiches-naturais",
    badge: "Favorito",
    nutrition: { calories: 258, proteins: 15.2, carbs: 26.8, fats: 10.5, sodium: 540, fiber: 2.3, unit: "por 100g" },
    detailedNutrition: {
      allergens: "Contém derivados de soja, trigo e ovo. Pode conter leite. Contém glúten.",
      conservation: "Manter refrigerado entre 0°C e 10°C. Ideal para consumo imediato após descongelamento.",
      shelfLife: "10 dias",
      rows: [
        { nutrient: "Valor energético (kcal)", per100g: "198", per40g: "77", vd: "4%" },
        { nutrient: "Carboidratos", per100g: "31 g", per40g: "12 g", vd: "4%" },
        { nutrient: "Açúcares totais", per100g: "4,5 g", per40g: "1,8 g", vd: "-" },
        { nutrient: "Açúcares adicionados", per100g: "4,5 g", per40g: "1,8 g", vd: "4%" },
        { nutrient: "Proteínas", per100g: "8,9 g", per40g: "3,5 g", vd: "7%" },
        { nutrient: "Gorduras totais", per100g: "4,3 g", per40g: "1,7 g", vd: "3%" },
        { nutrient: "Gorduras saturadas", per100g: "0,9 g", per40g: "0,3 g", vd: "2%" },
        { nutrient: "Gorduras trans", per100g: "0", per40g: "0", vd: "0%" },
        { nutrient: "Fibras alimentares", per100g: "1,9 g", per40g: "0,8 g", vd: "3%" },
        { nutrient: "Sódio", per100g: "437 mg", per40g: "175 mg", vd: "9%" },
      ],
    },
    conservation: "Manter refrigerado entre 0°C e 5°C. Ideal para consumo imediato após descongelamento.",
    shelfLife: "10 dias",
    storageTemp: "0°C a 5°C",
    tags: ["Favorito", "Proteico", "Colorido"],
  },
  {
    id: "frango-salada",
    name: "Frango Salada",
    shortDescription: "Leveza e frescor para o seu dia a dia.",
    fullDescription: "Para quem busca um lanche leve e refrescante, o sanduiche de Frango Salada é a escolha ideal. O frango desfiado é combinado com folhas de acelga fresca e rodelas de tomate maduro, criando uma combinacao saudavel e nutritiva. Este sanduiche é perfeito para quem quer manter uma alimentacao equilibrada sem abrir mao do sabor. Um lanche que refresca e alimenta ao mesmo tempo.",
    ingredients: ["Pão de forma", "Patê de filé de frango", "Tomate maduro", "Acelga fresca"],
    weight: "130g",
    price: 6.80,
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/3763ae82-fb57-4f57-8be0-3994ac458d43_compressed_FRANGO-SALADA.webp",
    gallery: [
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/3763ae82-fb57-4f57-8be0-3994ac458d43_compressed_FRANGO-SALADA.webp",
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/dc3213e2-dacf-4322-b387-e6b59204122c_compressed_sanduche_em_embalagem_colorida_ao_sol.webp",
    ],
    category: "sanduiches-naturais",
    badge: null,
    nutrition: { calories: 218, proteins: 14.5, carbs: 24.2, fats: 7.2, sodium: 460, fiber: 2.8, unit: "por 100g" },
    detailedNutrition: {
      allergens: "Contém derivados de soja, trigo e ovo. Pode conter leite. Contém glúten.",
      conservation: "Manter refrigerado entre 0°C e 5°C. Consumir em ate 48h após abertura da embalagem.",
      shelfLife: "10 dias",
      rows: [
        { nutrient: "Valor energético (kcal)", per100g: "186", per40g: "75", vd: "4%" },
        { nutrient: "Carboidratos", per100g: "27 g", per40g: "11 g", vd: "4%" },
        { nutrient: "Açúcares totais", per100g: "3,4 g", per40g: "1,4 g", vd: "-" },
        { nutrient: "Açúcares adicionados", per100g: "2,9 g", per40g: "1,2 g", vd: "2%" },
        { nutrient: "Proteínas", per100g: "12 g", per40g: "4,8 g", vd: "10%" },
        { nutrient: "Gorduras totais", per100g: "3,3 g", per40g: "1,3 g", vd: "2%" },
        { nutrient: "Gorduras saturadas", per100g: "0,7 g", per40g: "0,3 g", vd: "2%" },
        { nutrient: "Gorduras trans", per100g: "0", per40g: "0", vd: "0%" },
        { nutrient: "Fibras alimentares", per100g: "1,9 g", per40g: "0,8 g", vd: "3%" },
        { nutrient: "Sódio", per100g: "341 mg", per40g: "137 mg", vd: "7%" },
      ],
    },
    conservation: "Manter refrigerado entre 0°C e 5°C. Consumir em ate 48h após abertura da embalagem.",
    shelfLife: "10 dias",
    storageTemp: "0°C a 5°C",
    tags: ["Leve", "Fresco", "Saudavel"],
  },
  {
    id: "frango-ricota",
    name: "Frango com Ricota",
    shortDescription: "A cremosidade da ricota encontra o sabor do frango.",
    fullDescription: "O sanduiche de Frango com Ricota é uma criacao exclusiva da Big Mania que une dois mundos: a proteina magra do frango e a cremosidade suave da ricota. O patê de ricota caseiro é preparado com ervas frescas que perfumam cada mordida. Um sanduiche sofisticado e diferente, ideal para quem busca algo além do convencional com um toque gourmet.",
    ingredients: ["Pão de forma", "Patê de filé de frango", "Patê de ricota com ervas"],
    weight: "130g",
    price: 6.80,
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/987e3398-6bf1-48b1-ab46-57f6226b2f0a_compressed_FRANGO-COM-RICOTA.webp",
    gallery: [
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/987e3398-6bf1-48b1-ab46-57f6226b2f0a_compressed_FRANGO-COM-RICOTA.webp",
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/dc3213e2-dacf-4322-b387-e6b59204122c_compressed_sanduche_em_embalagem_colorida_ao_sol.webp",
    ],
    category: "sanduiches-naturais",
    badge: null,
    nutrition: { calories: 248, proteins: 16.8, carbs: 24.5, fats: 10.2, sodium: 510, fiber: 1.6, unit: "por 100g" },
    detailedNutrition: {
      allergens: "Contém derivados de soja, trigo, ovo e leite. Contém lactose. Contém glúten.",
      conservation: "Manter refrigerado entre 0°C e 5°C. Ricota fresca: consumir preferencialmente em ate 5 dias.",
      shelfLife: "10 dias",
      rows: [
        { nutrient: "Valor energético (kcal)", per100g: "214", per40g: "83", vd: "4%" },
        { nutrient: "Carboidratos", per100g: "29 g", per40g: "11 g", vd: "4%" },
        { nutrient: "Açúcares totais", per100g: "3,6 g", per40g: "1,4 g", vd: "-" },
        { nutrient: "Açúcares adicionados", per100g: "3 g", per40g: "1,2 g", vd: "2%" },
        { nutrient: "Proteínas", per100g: "10 g", per40g: "4 g", vd: "8%" },
        { nutrient: "Gorduras totais", per100g: "6,4 g", per40g: "2,6 g", vd: "4%" },
        { nutrient: "Gorduras saturadas", per100g: "2,8 g", per40g: "1,1 g", vd: "6%" },
        { nutrient: "Gorduras trans", per100g: "0", per40g: "0", vd: "0%" },
        { nutrient: "Fibras alimentares", per100g: "1,8 g", per40g: "0,7 g", vd: "3%" },
        { nutrient: "Sódio", per100g: "315 mg", per40g: "126 mg", vd: "6%" },
      ],
    },
    conservation: "Manter refrigerado entre 0°C e 5°C. Ricota fresca: consumir preferencialmente em ate 5 dias.",
    shelfLife: "10 dias",
    storageTemp: "0°C a 5°C",
    tags: ["Cremoso", "Gourmet", "Ricota"],
  },
  {
    id: "frango-milho",
    name: "Frango com Milho",
    shortDescription: "Simples, delicioso e sempre uma excelente escolha.",
    fullDescription: "Um classico que nunca decepciona. O sanduiche de Frango com Milho combina a suculencia do frango desfiado com o doce natural do milho verde. Uma combinacao simples mas irresistivel que agrada criancas e adultos. O sabor caseiro e reconfortante deste sanduiche o torna perfeito para lanches escolares, festas infantis ou um lanche rapido no trabalho.",
    ingredients: ["Pão de forma", "Patê de filé de frango", "Milho verde doce"],
    weight: "130g",
    price: 6.80,
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/ea58789e-c645-4438-bef2-c8f4b0c64686_compressed_FRANGO-COM-MILHO.webp",
    gallery: [
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/ea58789e-c645-4438-bef2-c8f4b0c64686_compressed_FRANGO-COM-MILHO.webp",
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/dc3213e2-dacf-4322-b387-e6b59204122c_compressed_sanduche_em_embalagem_colorida_ao_sol.webp",
    ],
    category: "sanduiches-naturais",
    badge: null,
    nutrition: { calories: 238, proteins: 14.8, carbs: 27.5, fats: 7.8, sodium: 480, fiber: 1.5, unit: "por 100g" },
    detailedNutrition: {
      allergens: "Contém derivados de soja, trigo e ovo. Pode conter leite. Contém glúten.",
      conservation: "Manter refrigerado entre 0°C e 5°C. Consumir fresco para melhor experiencia.",
      shelfLife: "10 dias",
      rows: [
        { nutrient: "Valor energético (kcal)", per100g: "179", per40g: "71", vd: "4%" },
        { nutrient: "Carboidratos", per100g: "28 g", per40g: "11 g", vd: "4%" },
        { nutrient: "Açúcares totais", per100g: "3,2 g", per40g: "1,3 g", vd: "-" },
        { nutrient: "Açúcares adicionados", per100g: "3 g", per40g: "1,2 g", vd: "2%" },
        { nutrient: "Proteínas", per100g: "10 g", per40g: "4,1 g", vd: "8%" },
        { nutrient: "Gorduras totais", per100g: "3 g", per40g: "1,2 g", vd: "2%" },
        { nutrient: "Gorduras saturadas", per100g: "0,7 g", per40g: "0,3 g", vd: "2%" },
        { nutrient: "Gorduras trans", per100g: "0", per40g: "0", vd: "0%" },
        { nutrient: "Fibras alimentares", per100g: "1,9 g", per40g: "0,8 g", vd: "3%" },
        { nutrient: "Sódio", per100g: "359 mg", per40g: "144 mg", vd: "7%" },
      ],
    },
    conservation: "Manter refrigerado entre 0°C e 5°C. Consumir fresco para melhor experiencia.",
    shelfLife: "10 dias",
    storageTemp: "0°C a 5°C",
    tags: ["Classico", "Infantil", "Suculento"],
  },
];

export const miniPasteis: Product[] = [
  {
    id: "mini-pastel-queijo",
    name: "Mini Pastel de Queijo Cremoso",
    shortDescription: "Crocante por fora, cremoso por dentro. Perfeito para qualquer ocasião.",
    fullDescription: "Nossos Mini Pasteis de Queijo Cremoso são uma verdadeira explosao de sabor em formato mini. A massa fina e crocante envolve um recheio generoso de queijo cremoso derretido que estica a cada mordida. Ideal para festas, coquetéis, coffee breaks e eventos corporativos. Cada caixa contém 100 unidades prontas para fritar ou assar, garantindo praticidade e sabor em qualquer ocasiao.",
    ingredients: ["Massa fina especial", "Queijo cremoso premium"],
    weight: "13g",
    price: 38.00,
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/d3fcdc31-6d6e-40b3-92db-0e18867a67e2_compressed_WhatsApp-Image-2026-07-20-at-17.27.43.webp",
    gallery: [
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/d3fcdc31-6d6e-40b3-92db-0e18867a67e2_compressed_WhatsApp-Image-2026-07-20-at-17.27.43.webp",
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/c6072b6f-28a6-48d0-904f-b1902e465368_compressed_WhatsApp-Image-2026-07-21-at-08.03.35.webp",
    ],
    category: "mini-pasteis",
    badge: "Mais Vendido",
    nutrition: { calories: 185, proteins: 5.2, carbs: 18.5, fats: 10.8, sodium: 320, fiber: 0.5, unit: "por 100g" },
    conservation: "Manter congelado a -18°C. Nao descongelar em temperatura ambiente.",
    shelfLife: "90 dias (congelado)",
    storageTemp: "-18°C",
    tags: ["Crocante", "Queijo", "Eventos"],
  },
  {
    id: "mini-pastel-carne",
    name: "Mini Pastel de Carne",
    shortDescription: "Recheio suculento de carne temperada na medida certa.",
    fullDescription: "O Mini Pastel de Carne da Big Mania é um classico irresistivel. A massa crocante envolve um recheio generoso de carne moida temperada com temperos especiais e cebola caramelizada. Cada caixa contém 100 unidades congeladas, prontas para serem fritas ou assadas. Um petisco que sempre faz sucesso em festas, churrascos e eventos de qualquer porte.",
    ingredients: ["Massa fina especial", "Carne moida temperada", "Cebola caramelizada"],
    weight: "13g",
    price: 38.00,
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/c6072b6f-28a6-48d0-904f-b1902e465368_compressed_WhatsApp-Image-2026-07-21-at-08.03.35.webp",
    gallery: [
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/c6072b6f-28a6-48d0-904f-b1902e465368_compressed_WhatsApp-Image-2026-07-21-at-08.03.35.webp",
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/d3fcdc31-6d6e-40b3-92db-0e18867a67e2_compressed_WhatsApp-Image-2026-07-20-at-17.27.43.webp",
    ],
    category: "mini-pasteis",
    badge: null,
    nutrition: { calories: 195, proteins: 7.8, carbs: 17.2, fats: 11.5, sodium: 380, fiber: 0.8, unit: "por 100g" },
    conservation: "Manter congelado a -18°C. Fritar em oleo bem quente para melhor crocancia.",
    shelfLife: "90 dias (congelado)",
    storageTemp: "-18°C",
    tags: ["Suculento", "Carne", "Classico"],
  },
  {
    id: "mini-pastel-frango",
    name: "Mini Pastel de Frango",
    shortDescription: "O sabor do frango em formato pratico e irresistivel.",
    fullDescription: "Os Mini Pasteis de Frango da Big Mania combinam a suculencia do frango desfiado temperado com uma massa leve e crocante. O recheio é preparado com frango selecionado, temperos aromaticos e um toque de requeijao que deixa cada mordida irresistivel. Cada caixa contém 100 unidades congeladas prontas para fritar ou assar, perfeitas para festas, lanches e eventos.",
    ingredients: ["Massa fina especial", "Frango desfiado temperado", "Requeijao cremoso"],
    weight: "13g",
    price: 38.00,
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/2687e363-8b11-4eee-b022-21189113963f_compressed_WhatsApp-Image-2026-07-21-at-08.03.34.webp",
    gallery: [
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/2687e363-8b11-4eee-b022-21189113963f_compressed_WhatsApp-Image-2026-07-21-at-08.03.34.webp",
      "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/d3fcdc31-6d6e-40b3-92db-0e18867a67e2_compressed_WhatsApp-Image-2026-07-20-at-17.27.43.webp",
    ],
    category: "mini-pasteis",
    badge: null,
    nutrition: { calories: 175, proteins: 8.5, carbs: 16.8, fats: 9.2, sodium: 340, fiber: 0.6, unit: "por 100g" },
    conservation: "Manter congelado a -18°C. Assar em forno preaquecido para opcao mais leve.",
    shelfLife: "90 dias (congelado)",
    storageTemp: "-18°C",
    tags: ["Frango", "Pratico", "Versatil"],
  },
];

export const allProducts = [...sandwiches, ...miniPasteis];

export function getProductById(id: string): Product | undefined {
  return allProducts.find((p) => p.id === id);
}

export function getRelatedProducts(currentId: string, limit = 3): Product[] {
  const current = getProductById(currentId);
  if (!current) return allProducts.slice(0, limit);
  return allProducts
    .filter((p) => p.id !== currentId && p.category === current.category)
    .slice(0, limit);
}

export const productCatalogInfo = {
  categoryInfo: {
    "sanduiches-naturais": {
      name: "Sanduíches Naturais",
      unitWeight: "130g",
      unitPrice: 6.80,
      availability: "Sabores diversos",
      shelfLife: "10 dias",
    },
    "mini-pasteis": {
      name: "Mini Pastéis",
      unitWeight: "13g",
      packageSize: "100 unidades",
      unitPrice: 38.00,
      availability: "Disponivel",
      shelfLife: "Consultar",
    },
  },
  orderNotes: {
    availability: "Devido à alta demanda, nem todos os produtos estão disponíveis para pronta entrega. Consulte a disponibilidade antes de realizar o pedido.",
    delivery: "As entregas são realizadas através de rotas programadas devido ao grande volume de pedidos. Por esse motivo, não é possível garantir horário exato de entrega. Entregas gratuitas disponíveis para pedidos no atacado. Horário: Segunda a sexta, 07h às 17h.",
    storage: "Os produtos devem ser armazenados resfriados ou congelados, conforme orientação de cada item.",
    exchangePolicy: "Não realizamos trocas de produtos vencidos enquanto estiverem sob responsabilidade do cliente ou produtos que não tenham sido comercializados por falta de rotatividade. Em caso de avaria, informar no momento do recebimento para substituição.",
    paymentMethods: ["PIX", "Dinheiro", "Transferência bancária", "Boleto bancário (mediante análise de crédito)"],
  },
};